import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import Orders from "../../components/User/Orders";

export default withRouter(connect()(Orders));
